module.exports = __webpack_public_path__ + "static/media/s_7.97cb5005.mp3";